/**
 * @fileoverview POST handler for the "/engagement/braze_report_dashboard" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementBrazeReportDashboardCacheKeys } from "./constants";
import type { PostEngagementBrazeReportDashboardProps, EngagementBrazeReportDashboardResult } from "./types";

export const postEngagementBrazeReportDashboard = reactQueryMutationAdapter(
  engagementBrazeReportDashboardCacheKeys,
  (props: PostEngagementBrazeReportDashboardProps): Promise<EngagementBrazeReportDashboardResult> => {
    return fetch("/engagement/braze_report_dashboard", "POST", props);
  }
);
